import script from "./FeaturesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturesList.vue?vue&type=script&setup=true&lang=ts"

import "./FeaturesList.vue?vue&type=style&index=0&id=26579fd7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26579fd7"]])

export default __exports__